import { render, staticRenderFns } from "./OrderFieldDropdown.vue?vue&type=template&id=6f5e1499&scoped=true"
import script from "./OrderFieldDropdown.vue?vue&type=script&lang=js"
export * from "./OrderFieldDropdown.vue?vue&type=script&lang=js"
import style0 from "./OrderFieldDropdown.vue?vue&type=style&index=0&id=6f5e1499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e1499",
  null
  
)

export default component.exports